import React from 'react';
import EllipsisTextBubble, { IEllipsisTextBubbleProps } from '@gp/components/EllipsisTextBubble';

const StudioEllipsisTextBubble: React.FC<IEllipsisTextBubbleProps> = (props) => (
  <EllipsisTextBubble {...props} lineHeight={18} />
);

export default StudioEllipsisTextBubble;
